import React from 'react'
import { Link } from "react-router-dom";

// components
import Datos from 'components/fanpageMessage'
import MetaTags from 'components/metatags'

const DatosPage = () => (
    <>
        <MetaTags title='Mensajes' description='Mensajes de páginas' />
        <Datos />
    </>
)

export default DatosPage
